import Vue from "vue";
import Router from "vue-router";

// Containers
import Full from "@/containers/Full.vue";

// Views
import Login from "@/views/admin/Login.vue";
import Acl from "@/views/admin/Acl.vue";
import Translator from "@/views/admin/Translator.vue";
import Languages from "@/views/admin/Languages.vue";
import SiteProps from "@/views/admin/SiteProps.vue";
import EmailTemplates from "@/views/admin/EmailTemplates.vue";
// import UserCompanies from '@/views/admin/UserCompanies.vue';
import CompanyType from "@/views/admin/CompanyType.vue";
import Users from "@/views/users/Win.vue";
import userDocuments from "@/views/users/UserDocuments.vue";

import UserCompanies from "@/views/user_companies/Win.vue";

import Dashboard from "@/views/dashboard/Dashboard.vue";

import Event from "@/views/events/Event.vue";

import Child from "@/views/child/Win.vue";
import ChildDetails from "@/views/child/WinDetails.vue";
import Parents from "@/views/parent_new/Win.vue";
import ParentsDetails from "@/views/parent_new/WinDetails.vue";

import TherapyType from "@/views/therapytype/Win.vue";
import WorkType from "@/views/worktype/Win.vue";
import Diagnose from "@/views/diagnose/Win.vue";

import Room from "@/views/room/Win.vue";

import Note from "@/views/note/Win.vue";

import WorkingGroup from "@/views/working_group/WorkingGroupWin.vue";
import WorkingGroupEvent from "@/views/working_group/WorkingGroupEventWin.vue";

import Notifications from "@/views/notifications/Win.vue";

import VolunteersAssociates from "@/views/volunteers_associates/Win.vue";

import GroupWaitingList from "@/views/group_waiting_list/Win.vue";
import WaitlistIndividualSessions from "@/views/waitlist_individual_sessions/Win.vue";
import Statistics from '@/views/statistics/Win.vue';
// GENERATORLASTITEM

Vue.use(Router);

export default new Router({
    mode: "history",
    base: "/admin/",
    routes: [
        {
            path: "/dashboard",
            name: "HOME",
            component: Full,
            children: [
                {
                    path: "",
                    name: "DASHBOARD",
                    component: Dashboard,
                },
            ],
        },
        {
            path: "/event",
            name: "EVENT",
            component: Full,
            children: [
                {
                    path: "",
                    name: "EVENT",
                    component: Event,
                },
            ],
        },
        {
            path: "/children",
            name: "CHILDREN",
            component: Full,
            children: [
                {
                    path: "child",
                    name: "CHILD",
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "",
                            name: "CHILD",
                            component: Child,
                        },
                        {
                            path: "childdetails/:childId",
                            name: "CHILDDETAILS",
                            component: ChildDetails,
                        },
                    ],
                },
                {
                    path: "parents",
                    name: "PARENTS",
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "",
                            name: "PARENTS",
                            component: Parents,
                        },
                        {
                            path: "parentsdetails/:childId",
                            name: "PARENTSDETAILS",
                            component: ParentsDetails,
                        },
                    ],
                },
            ],
        },
        {
            path: "/therapy",
            name: "THERAPY",
            component: Full,
            children: [
                {
                    path: "therapytype",
                    name: "THERAPYTYPE",
                    component: TherapyType,
                },
                {
                    path: "worktype",
                    name: "WORKTYPE",
                    component: WorkType,
                },
                {
                    path: "diagnose",
                    name: "DIAGNOSE",
                    component: Diagnose,
                },
            ],
        },
        {
            path: "/room",
            name: "HOME",
            component: Full,
            children: [
                {
                    path: "",
                    name: "ROOM",
                    component: Room,
                },
            ],
        },
        {
            path: '/admin/statistics',
            name: 'HOME',
            component: Full,
            children: [
                {
                    path: '',
                    name: 'STATISTICS',
                    component: Statistics,
                },
            ],
        },
        {
            path: "/group_waiting_list",
            name: "HOME",
            component: Full,
            children: [
                {
                    path: "",
                    name: "GROUPWAITINGLIST",
                    component: GroupWaitingList,
                },
            ],
        },
        {
            path: "/waitlist_individual_sessions",
            name: "HOME",
            component: Full,
            children: [
                {
                    path: "",
                    name: "WAITLISTINDIVIDUALSESSIONS",
                    component: WaitlistIndividualSessions,
                },
            ],
        },
        {
            path: "/workinggroup",
            name: "WORKINGGROUP",
            component: Full,
            children: [
                {
                    path: "",
                    name: "WORKINGGROUP",
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "",
                            name: "WORKINGGROUP",
                            component: WorkingGroup,
                        },
                        {
                            path: "workinggroupevent/:workingGroupId",
                            name: "WORKINGGROUPEVENT",
                            component: WorkingGroupEvent,
                        },
                    ],
                },
                {
                    path: "",
                    name: "WORKINGGROUP",
                    component: WorkingGroup,
                },
            ],
        },
        {
            path: "/note",
            name: "HOME",
            component: Full,
            children: [
                {
                    path: "",
                    name: "NOTE",
                    component: Note,
                },
            ],
        },
        {
            path: "/volunteersassociates",
            name: "HOME",
            component: Full,
            children: [
                {
                    path: "",
                    name: "VOLUNTEERSASSOCIATES",
                    component: VolunteersAssociates,
                },
            ],
        },
        {
            path: "/notifications",
            name: "HOME",
            component: Full,
            children: [
                {
                    path: "",
                    name: "NOTIFICATIONS",
                    component: Notifications,
                },
            ],
        },
        {
            path: "/system",
            name: "SYSTEM",
            component: Full,
            children: [
                {
                    path: "acl",
                    name: "ACL",
                    component: Acl,
                },
                {
                    path: "translator",
                    name: "TRANSLATOR",
                    component: Translator,
                },
                {
                    path: "languages",
                    name: "LANGUAGES",
                    component: Languages,
                },
                {
                    path: "siteprops",
                    name: "SITEPROPS",
                    component: SiteProps,
                },
                {
                    path: "emailtemplates",
                    name: "EMAILTEMPLATES",
                    component: EmailTemplates,
                },
                {
                    path: "usercompanies",
                    name: "USERCOMPANIES",
                    component: UserCompanies,
                },
                {
                    path: "companytype",
                    name: "COMPANYTYPE",
                    component: CompanyType,
                },
                {
                    path: "users",
                    name: "USERS",
                    component: {
                        render(c) {
                            return c("router-view");
                        },
                    },
                    children: [
                        {
                            path: "",
                            name: "USERS",
                            component: Users,
                        },
                        {
                            path: "userdocuments/:userId",
                            name: "USERDOCUMENTS",
                            component: userDocuments,
                        },
                    ],
                },
            ],
        },
        {
            path: "/login",
            name: "LOGIN",
            component: Login,
        },
    ],
});
